import { SimpleMutationOptions, useBaseMutation } from "../baseMutation";
import { RemoveFolderByIdRequest, RemoveFolderByIdResponse } from "@maven-rest/docs/Folder.dto";
import { FolderUrl } from "@maven-rest/docs/Folder.url";

export function useRemoveFolderMutation(
  pathVariable: Pick<RemoveFolderByIdRequest, "folderId">,
  options?: SimpleMutationOptions<RemoveFolderByIdResponse, RemoveFolderByIdRequest>
) {
  return useBaseMutation({
    fnOption: {
      url: FolderUrl.removeFolderById(pathVariable.folderId),
    },
    ...options,
  });
}
